import React from 'react'
import LogoIMage from '../../../images/main-logo.png'
const LoginInfo = () => {
  return (
    <div className='position-relative z-2'>
       <img src={LogoIMage} alt="" />
    </div>
  )
}

export default LoginInfo